import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { PageLoadingProvider } from './contexts/PageLoadingContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import App from './App'

// Inicializa i18n
import './i18n'

// Importa todos os estilos (ordem importa!)
import './styles/index.css'

// Note: roundedBar chart type é registrado no index.html junto com Chart.js

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <AuthProvider>
          <PageLoadingProvider>
            <App />
          </PageLoadingProvider>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)
